import React from "react";
import ColumnInput from "./ColumnInput";
const UniqueIdColumnInput = ({ uniqueIdColumn, dataset, onChange, menuPlacement }) => {
    const columns = Object.keys((dataset || {}).fields || {}).filter((field) => dataset?.fields?.[field]?.data?.length ?? 0 > 1);
    return (React.createElement(ColumnInput, { column: uniqueIdColumn, columns: columns, onChange: onChange, menuPlacement: menuPlacement, isClearable: true }));
};
export default UniqueIdColumnInput;
